<template>
  <div class="hm-tags-container">
    <HMTag
      v-for="tag in tags"
      class="mb-2 mr-2 smaller"
      :key="tag.id"
      :title="tag.name"
      :ref="`tag-${tag.id}`"
    />
  </div>
</template>

<script>
export default {
  name: 'HMTagsContainer',
  props: {
    tags: {
      type: Array,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-tags-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
